import { securedFetch } from "../../auth/authService";
import { DEVICE_API } from "../../vars";

export function getDeviceSSHAlgorithm(deviceId) {
    return securedFetch(`${DEVICE_API}/sshalgorithm/${deviceId}`)
        .then(response => response.json())
        .then(data => {
            return data;
        });
}

export async function saveDeviceSSHAlgorithm(sshAlgorithmOption) {
    try {
        const response = await securedFetch(`${DEVICE_API}/sshalgorithm?deviceId=${sshAlgorithmOption.deviceId}`, { sshalgorithm: sshAlgorithmOption.sshAlgorithm }, 'POST');
        if (response.ok) {
            const device = await response.json();
            return device;
        }
    } catch (error) {
        console.error("Error while saving device SSH algorithm:", error);
        throw error;
    }
}

// export async function validateSShAlgorithmOptionsFormat(sshAlgorithmOption){
//     //    alert(sshAlgorithmOption.sshAlgorithm)
//         const token = sessionStorage.getItem('access_token');
//         return fetch(`${DEVICE_API}/validatesshalgorithm`,
//         {
//             method: 'POST',
//             headers: {
//                 // 'Content-Type': 'text/plain',
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + token
//             },
//             body: JSON.stringify({sshalgorithm: sshAlgorithmOption.sshAlgorithm})
//         }).then(async response => {
//            const message= await response.text();
//            return message
//         })
    
//     }

export async function validateSShAlgorithmOptionsFormat(sshAlgorithmOption) {
    try {
        //    alert(sshAlgorithmOption.sshAlgorithm)
        const token = sessionStorage.getItem('access_token');
        const response = await fetch(`${DEVICE_API}/validatesshalgorithm`, {
            method: 'POST',
            headers: {
                // 'Content-Type': 'text/plain',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify({ sshalgorithm: sshAlgorithmOption.sshAlgorithm })
        })

        let message = await response.text();
        // if (!response.ok) {
        //     message = await response.text();
        //     //return message;
        // }
        return message;
    } catch (error) {
        console.error("Error while validating SSH algorithm options format:", error);
        throw error;
    }
}

// export async function validateSShAlgorithmOptionsFormat(sshAlgorithmOption){
//     try {
//         return securedFetch(`${DEVICE_API}/validatesshalgorithm`,{sshalgorithm:sshAlgorithmOption.sshAlgorithm},'POST')
//         .then(response => {
//             if(!response.ok) {            
//                 const msg=response.json();
//                 return msg;
//             } else {              
//                 const msg=response.json();
//                 return msg;
//             }
//         })
//         // .then(data => {
//         //     return data;
//         // });

//     }
//     catch (err) {
//         alert(err)
//     }

// }

export async function changeDeviceSSHAlgorithm(parameter) {
    try {
        const response = await securedFetch(`${DEVICE_API}/${parameter.id}`, parameter, 'POST');
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error while changing device SSH algorithm:", error);
        throw error;
    }
}
